import { useEffect, useRef, useState } from 'react';

import Styles from './Stopwatch.module.css';

const Stopwatch = ({ resetStopwatch, running = false, onElapsedChange }) => {
  const [elapsedTime, setElapsedTime] = useState(0);
  const intervalIdRef = useRef(null);
  const startTimeRef = useRef(null);

  useEffect(() => {
    if (running) {
      startTimeRef.current = Date.now();
      intervalIdRef.current = setInterval(() => {
        const t = Date.now() - startTimeRef.current;
        setElapsedTime(t);
        if (onElapsedChange) onElapsedChange(t);
      }, 10);
    } else {
      if (intervalIdRef.current) {
        clearInterval(intervalIdRef.current);
        intervalIdRef.current = null;
        // eslint-disable-next-line no-console
      }
    }

    return () => {
      if (intervalIdRef.current) {
        clearInterval(intervalIdRef.current);
        intervalIdRef.current = null;
      }
    };
  }, [running, onElapsedChange]);

  function formatTime() {
    let minutes = Math.floor((elapsedTime / (1000 * 60)) % 60);
    let seconds = Math.floor((elapsedTime / 1000) % 60);
    let milliseconds = Math.floor((elapsedTime % 1000) / 10);

    minutes = String(minutes).padStart(2, '0');
    seconds = String(seconds).padStart(2, '0');
    milliseconds = String(milliseconds).padStart(2, '0');

    return `${minutes}:${seconds}:${milliseconds}`;
  }

  useEffect(() => {
    // Reset display when parent asks for it
    setElapsedTime(0);
    if (onElapsedChange) onElapsedChange(0);
    // don't automatically start timer on reset
  }, [resetStopwatch, onElapsedChange]);

  return (
    <div className={Styles.time}>
      <p>{formatTime()}</p>
    </div>
  );
};

export default Stopwatch;
